import React from "react";
import {
    Box,
    Text,
    Stack,
    Badge,
    Spinner,
    Alert,
    AlertIcon,
    VStack,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const CouponCard = () => {
    const couponList = useSelector((state) => state.couponList);
    const { loading: loadingCoupon, error: errorCoupon, coupons } = couponList;

    if (loadingCoupon) return <Spinner size="lg" color="blue.500" />;
    if (errorCoupon)
        return (
            <Alert status="error">
                <AlertIcon />
                {errorCoupon}
            </Alert>
        );

    return (
        <VStack spacing={4} align="stretch">
            {coupons?.map((coupon) => (
                <Box
                    key={coupon._id}
                    borderWidth="1px"
                    borderRadius="md"
                    boxShadow="md"
                    px={4}
                    py={1}
                    bg="white"
                >
                    <Stack spacing={2}>
                        <Text fontSize="lg" fontWeight="bold">
                            {coupon.name}
                        </Text>
                        <Text fontSize="14px">
                            Code: <strong>{coupon.code}</strong>
                        </Text>
                        <Text fontSize="14px">
                            Discount:{" "}
                            <Badge colorScheme="green">{coupon.discount}{coupon.type === "fixed" ? " OFF" : "% OFF"}</Badge>
                        </Text>
                        <Text fontSize="14px">
                            Valid Till: {dayjs(coupon.endDate).format("DD MMM, hh:mm A")}
                        </Text>

                    </Stack>
                </Box>
            ))}
        </VStack>
    );
};

export default CouponCard;
